import { createContext } from "react";
const VerticalsContext = createContext();
export default VerticalsContext;